import { isSSR as r } from "./isSSR.js";
import { isString as m } from "lodash";
const s = (e, l) => {
    var n, t;
    if (r() || !m(e)) return null;
    const i = new RegExp("(^|;)\\s*" + e + "\\s*=\\s*([^;]+)");
    try {
      const o = ((t = (n = i.exec(document == null ? void 0 : document.cookie)) == null ? void 0 : n.pop()) == null ? void 0 : t.trim()) || null;
      return o !== null ? decodeURIComponent(o) : null;
    } catch (o) {
      l == null || l(o == null ? void 0 : o.message);
    }
    return null;
  },
  a = (e, l, n, t, i, o) => {
    try {
      const u = ".olx.com.br",
        c = i ? "max-age=".concat(i) : "";
      document.cookie = "".concat(e, "=").concat(l, "; domain=").concat(u, "; path=").concat(n != null ? n : "/", "; samesite=").concat(t || "Lax", "; ").concat(c);
    } catch (u) {
      o == null || o(u == null ? void 0 : u.message);
    }
  };
export { s as getCookie, a as setCookie };